module.exports = __webpack_public_path__ + "static/media/48365716_2308758435866001_5691333942150430720_o-thumb.cc9fd55f.jpg";